import type { IconData } from '@stacksjs/iconify-core'

export const otherUiHash: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m5 16l.75-3h2L7 16h4l.75-3h1.75l1-4h-1.75l.5-2H15l1-4h-1.75L15 0h-4l-.75 3h-2L9 0H5l-.75 3H2.5l-1 4h1.75l-.5 2H1l-1 4h1.75L1 16zm2.25-9l-.5 2h2l.5-2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiHash
